import type { Paragraph } from '@/api/types/stowed-element'
import { paragraphsToPlainText } from '@/lib/shapes/shape-text'

/**
 * Caret-offset length of `paragraphs` in the **shape-text** character convention — paragraphs joined
 * by `\n`, inner `textLines`/`textRuns` concatenated with no separator, `isHidden` lines counted.
 *
 * A shape's offset is fed straight to `textarea.setSelectionRange`, whose string is
 * `paragraphsToPlainText(paragraphs)`, so a chain hand-off must measure the destination frame this
 * way. Any other join (for example one that separates inner `textLines` with `\n`) disagrees for a
 * paragraph holding more than one `textLine` — which real yb360 data does, since one `<PG>` may
 * contain several `<TL>` (see `split-shape-text-paragraphs.ts`) — and misplaces the caret silently
 * (WMPCM-9070).
 */
export function measureShapeParagraphsPlainTextLength(paragraphs: Paragraph[]): number {
  return paragraphsToPlainText(paragraphs).length
}
